import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=6f73b914&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=6f73b914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73b914",
  null
  
)

export default component.exports